import { fotaView } from "../constants/common-constants";
import fotaViewTypeEnum, { ModuleToOpen } from "../constants/fota-view-type-enum";
import roleTypeEnum from "../constants/role-type-enum";
import userTypeEnum from "../constants/user-type-enum";

export const getRoleTypeFromLocalStorage = () => {
    let roleType = localStorage.getItem('mzl_role_type');
    let role = roleType ? roleType : roleTypeEnum.TenantAdmin.toString();
    return parseInt(role);
}

export const getUserTypeFromLocalStorage = () => {
    let userType = localStorage.getItem('mzl_user_type');
    let type = userType ? userType : userTypeEnum.TenantUser.toString();
    return parseInt(type);
}

export const getTenantIdFromLocalStorage = () => {
    let tenantId = localStorage.getItem('mzl_tenantId');
    let id = tenantId ? tenantId : "-1";
    return parseInt(id);
}

export const getLoggedInTenantIdFromLocalStorage = () => {
    let tenantId = localStorage.getItem('mzl_login_tenantId');
    let id = tenantId ? tenantId : "-1";
    return parseInt(id);
}

export const getLoggedInTenantOrganizationIdFromLocalStorage = () => {
    let id = localStorage.getItem('mzl_organizationId');
    return id ? id : "";;
}

export const getSelectedResendFromLocalStorage = () => {
    let email = localStorage.getItem('mzl_selected_resend_email');
    let teampEmail = email ? email : "";
    return teampEmail;
}

export const getEmailFromLocalStorage = () => {
    let email = localStorage.getItem('mzl_email');
    let teampEmail = email ? email : "";
    return teampEmail;
}

export const getTokenFromLocalStorage = () => {
    let token = localStorage.getItem('mzl_token');
    return token ? token : "";
}

export const getRoleNameFromLocalStorage = () => {
    let roleName = localStorage.getItem('mzl_role_name');
    return roleName ? roleName : "";
}

export const getPermissionsFromLocalStorage = () => {
    let permissions = localStorage.getItem('mzl_permissions');
    return permissions ? permissions : [];
}

export const getLanguageFromLocalStorage = () => {
    let language = localStorage.getItem('mzl_language');
    return language ? language : 'en';
}

export const getFotaSelectedViewFromLocalStorage = () => {
    let view = localStorage.getItem('mzl_selected_view');
    return view !== null && view !== "" ? view : fotaView.HOST;
}

export const getThemeFromLocalStorage = () => {
    let theme = localStorage.getItem('mzl_darkTheme');
    return theme ? theme == "true" : false;
}

export const getFotaNewFromLocalStorage = () => {
    let view = localStorage.getItem('mzl_selected_view');
    if(view){
        let viewDetails = JSON.parse(view);
        if(viewDetails.view !== null && viewDetails.moduleToOpen !== null)
            return {view: viewDetails.view, moduleToOpen: viewDetails.moduleToOpen}
    }
    return {view: getUserTypeFromLocalStorage() == userTypeEnum.SystemUser ? fotaViewTypeEnum.Modem : fotaViewTypeEnum.Host, moduleToOpen: ModuleToOpen.Schedule}
}